<div class="min-h-screen bg-white font-inter text-slate-950">
  <div class="grid min-h-screen lg:grid-cols-[2fr_3fr]">

    <div class="auth-brand-panel relative hidden overflow-hidden bg-slate-950 lg:flex lg:flex-col">
      <div
        class="pointer-events-none absolute inset-0 bg-gradient-to-br from-black/80 via-black/75 to-black/90">
      </div>
      <div class="pointer-events-none absolute -right-24 -top-24 h-96 w-96 rounded-full bg-primary-600/10 blur-3xl">
      </div>
      <div class="pointer-events-none absolute -bottom-32 -left-16 h-80 w-80 rounded-full bg-primary-400/10 blur-3xl">
      </div>

      <div class="relative flex h-full flex-col justify-between px-10 py-12 xl:px-16">
        <a routerLink="/" class="inline-flex items-center gap-3">
          <img src="assets/brand/logo.svg" width="40" height="40" alt="FormOps logo"
            class="h-10 w-10 shrink-0 rounded-2xl bg-white p-1.5 shadow-lg shadow-black/20" />
          <div>
            <p class="text-h6 text-white">FormOps</p>
            <p class="text-caption text-slate-400">AI Workflow Platform</p>
          </div>
        </a>

        <div class="flex flex-col gap-4">
          <p class="text-body3 font-medium uppercase tracking-widest text-primary-400">Company setup</p>
          <h1 class="text-h2 text-white">Name your company</h1>
          <p class="text-body1 text-slate-400">
            Your company owns billing and limits. Name your first workspace to get started.
          </p>
        </div>

        <p class="text-caption text-slate-600">© {{ currentYear }} FormOps. All rights reserved.</p>
      </div>
    </div>

    <div class="flex flex-col justify-center bg-white px-6 py-12 sm:px-10 lg:px-16 xl:px-24">
      <div class="mx-auto flex w-full max-w-lg flex-col gap-10">

        <a routerLink="/" class="inline-flex items-center gap-3 lg:hidden">
          <img src="assets/brand/logo.svg" width="40" height="40" alt="FormOps logo"
            class="h-10 w-10 shrink-0 rounded-2xl bg-white p-1.5 shadow-lg shadow-black/20" />
          <div>
            <p class="text-h6 text-slate-950">FormOps</p>
            <p class="text-caption text-slate-500">AI Workflow Platform</p>
          </div>
        </a>

        <div class="flex flex-col gap-8">
          <div class="flex flex-col gap-2">
            <h2 class="text-h3 font-light text-slate-950">Create your company</h2>
            <p class="text-body1 text-slate-500">
              Tell us your company name to finish setting up your account.
            </p>
          </div>

          <form [signalForm]="companyForm">
            <div class="flex flex-col gap-5">
              <lib-signal-text-field
                [formField]="companyForm.companyName"
                label="Company name"
                placeholder="Acme Corp"
                autocomplete="organization" />

              <lib-signal-text-field
                [formField]="companyForm.workspaceName"
                label="Workspace name"
                placeholder="Default Workspace" />

              <div class="pt-2">
                <lib-signal-button
                  [loading]="createState.loading()"
                  [disabled]="createState.loading() || !canSubmit()"
                  [fullWidth]="true"
                  (clicked)="onSubmit()">
                  Continue
                </lib-signal-button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
